<template>
  <div>
    <PageHeader title="Offres" />
    <SearchToolbar
      class="mb-6"
      :placeholder="'Recherche par nom, référence...'"
      :initial-keywords="keywords"
      :available-filters="availableFilters"
      :selected-filters="selectedFilters"
      @update-keyword-search="updateKeywordSearch"
      @update-filter-search="updateFilterSearch"
    />
    <Table :columns="columns" :data="contractDistributions" :is-row-clickable="true" @rowClick="rowClick">
      <template #category="{ row }">
        <span>{{ $t(`contract_distributions.category.${row.category}`) }}</span>
      </template>
      <template #enabled="{ row }">
        <FieldSpan
          :style-to-add="row.enabled ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'"
          :value="row.enabled ? 'Oui' : 'Non'"
        />
      </template>
      <template #renewalAvailable="{ row }">
        <FieldSpan
          :style-to-add="row.renewalAvailable ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'"
          :value="row.renewalAvailable ? 'Oui' : 'Non'"
        />
      </template>
    </Table>
    <Pagination
      :currentPage="currentPage"
      :totalPages="totalPages"
      :totalCount="totalCount"
      @changePage="handleChangePage"
    />
  </div>
</template>

<script>
import { PageHeader, Pagination, Table, FieldSpan, SearchToolbar } from "@estaly/ui";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  components: { PageHeader, FieldSpan, Pagination, Table, SearchToolbar },

  data() {
    return {
      contractDistributions: [],
      columns: [
        { label: "Catégorie", field: "category", slot: "category" },
        { label: "Assureur", field: "insurerName" },
        { label: "Réference", field: "insurerContractGroupReference" },
        { label: "Actif", slot: "enabled", field: "enabled" },
        { label: "Renouvelable", slot: "renewalAvailable", field: "renewalAvailable" },
      ],
    };
  },

  computed: {
    ...mapState("contractDistributions", [
      "currentPage",
      "totalPages",
      "totalCount",
      "availableFilters",
      "selectedFilters",
      "keywords",
    ]),
    ...mapState("insurers", { insurers: "index" }),
  },

  async created() {
    this.setFilter({ filterName: "status", filterOptions: [true] });
    await this.fetchInsurersIndex();
    this.setAvailableFilters({
      filterName: "insurers",
      options: this.insurers?.map((insurer) => insurer.name) || [],
    });
    this.getContractDistributions();
  },

  methods: {
    ...mapActions("contractDistributions", { fetchContractDistributions: "fetchIndex" }),
    ...mapActions("insurers", { fetchInsurersIndex: "fetchIndex" }),
    ...mapMutations("contractDistributions", ["setAvailableFilters", "setFilter", "setKeywords"]),

    async getContractDistributions(page = 1) {
      const { status, ...filters } = this.selectedFilters;
      const enabled = status?.length === 1 ? status[0] : undefined;
      const data = await this.fetchContractDistributions({
        page,
        keywords: this.keywords,
        ...filters,
        enabled,
        includes: ["insurer"],
      });

      this.contractDistributions = data.contractDistributions.map((cd) => ({
        ...cd,
        insurerName: cd.insurer?.name,
      }));
    },

    updateKeywordSearch(keywords) {
      this.setKeywords(keywords);
      this.getContractDistributions(1);
    },

    updateFilterSearch(filterName, filterOptions) {
      this.setFilter({ filterName, filterOptions });
      this.getContractDistributions(1);
    },

    handleChangePage(page) {
      this.getContractDistributions(page);
    },

    rowClick(row) {
      this.$router.push(`/contract-distributions/${row.id}`);
    },
  },
};
</script>
